import React from "react";

// Anchor Point Industries "A" monogram — recreated to match the brand mark.
// Defaults render for dark backgrounds (light body + steel accent leg).
export const Logo = ({ className = "", markOnly = false, body = "#F5F7F8", accent = "#8A99A8" }) => {
  return (
    <div className={`flex items-center gap-3 ${className}`} data-testid="site-logo">
      <svg
        viewBox="0 0 120 118"
        width="36"
        height="36"
        className="shrink-0"
        aria-label="Anchor Point Industries"
      >
        <g strokeLinecap="butt" fill="none">
          <path d="M12 108 L60 10" stroke={body} strokeWidth="19" />
          <path d="M60 10 L85 61" stroke={body} strokeWidth="19" />
          <path d="M91.5 74 L108 108" stroke={accent} strokeWidth="19" />
          <path d="M33 78 L74 78" stroke={body} strokeWidth="13" />
        </g>
      </svg>
      {!markOnly && (
        <div className="leading-none">
          <div className="font-display font-extrabold text-[15px] tracking-tight uppercase text-foreground">
            Anchor Point
          </div>
          <div className="font-mono-tech text-[9px] tracking-[0.3em] uppercase text-steel mt-0.5">
            Industries LLC
          </div>
        </div>
      )}
    </div>
  );
};
